<ng-container>
    <div class="content-width">
        <div class="mt-4 mb-4">
            <span *ngIf="page === 'AccessAdvice'" [innerHTML]="'LegalPage.AccessAdvice' | translate"></span>
            <span *ngIf="page === 'Cookies'" [innerHTML]="content | sanitizeHtml"></span>
            <span *ngIf="page === 'PrivacyPolicy'" [innerHTML]="content | sanitizeHtml"></span>
            <span *ngIf="page === 'TermsOfUse'" [innerHTML]="'LegalPage.TermsOfUse' | translate"></span>
        </div>
    </div>
</ng-container>